module.exports = "<div class='main' *ngIf='project'>\n  Unique: {{unique}} //\nTotal: {{total}} <button (click)='exportIDs()'>Export IDs</button> //\n <a [href]='sbucketURL' target='_blank'>Searches Bucket</a> //\n<a [href]='fbucketURL' target='_blank'>Files Bucket</a> \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/project-db-records-stats/project-db-records-stats.component.html
// module id = 436
// module chunks = 0